"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORG_NOTIFICATION_TEMPLATE_NAMES = void 0;
exports.ORG_NOTIFICATION_TEMPLATE_NAMES = [
    "BANK_ACCOUNT_UPDATE",
    "PAYOUT_PAUSED",
    "ORGANIZATION_PAYOUT_CREATED",
    "ORGANIZATION_NEGATIVE_PAYOUT_CREATED",
    "ORGANIZATION_PAYOUT_FAILED",
    "FIRST_PROCESSED_PAYMENT_WITHOUT_CONNECTED_BANK_ACCOUNT",
    "ORGANIZATION_STRIPE_INFORMATION_REQUIRED",
    "ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER",
    "ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED",
    "STRIPE_VERIFICATION_COMPLETED",
    "NEXT_DAY_PAYOUTS_ENABLED",
    "ORGANIZATION_FIRST_PAYMENT_RECEIVED_EMAIL",
    "ORGANIZATION_FAILED_PAD_ACH",
    "ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT",
    "ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE",
    "ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE",
    "ORGANIZATION_PAST_DUE_SUBSCRIPTION",
    "EXPORT_COMPLETED",
    "IMPORT_COMPLETED",
    "IMPORT_FAILED",
    "NEWSLETTER_SIGNUP_NOTIFICATION",
    "REFERRAL_FIRST_REFEREE_TRANSACTION",
    "REFERRAL_FIRST_REFEREE_PAYOUT",
    "REFERRAL_DURING_ONBOARDING",
    "REFERRAL_DURING_SIGN_UP",
    "TIPS_UPCOMING_EVENT",
    "CHECK_IN_MANAGER_UPCOMING_EVENT",
    "AUCTION_CLOSED",
    "AUCTION_ORGANIZATION_BID_SUBMITTED",
    "AUCTION_FAILED_PAYMENT",
    "SUPPORT_SERVER_ERROR",
    "CUSTOM_DOMAIN_FAILED",
    "CUSTOM_DOMAIN_SUCCEEDED",
    "WEBHOOK_AUTO_DISABLED",
    "NBCTC_NEW_LEAD_SIGNED_UP",
    "SCHEDULED_EMAIL_CONFIRMATION",
    "QUICKBOOKS_DISCONNECTED_NOTIFICATION",
    "ISSUING_CARD_IS_ON_THE_WAY",
    "ISSUING_CARD_HAS_BEEN_ACTIVATED",
    "ISSUING_EXPENSE_FAILED",
    "ISSUING_TOPUP_SUCCEED",
    "ISSUING_REWARD_SUCCEEDED",
    "CREATED_FINANCIAL_ACCOUNT",
    "ADDED_BENEFICIARY",
    "LOW_TREASURY_BALANCE",
    "TREASURY_BETA_INVITATION",
    "RECEIVED_CREDIT",
    "OUTBOUND_PAYMENT_POSTED",
    "OUTBOUND_PAYMENT_FAILED",
    "WEEKLY_REPORT",
    "WEEKLY_REPORT_NO_RECURRING",
    "WEEKLY_REPORT_NO_ONE_TIME",
    "MONTHLY_REPORT_PAYOUT_MULTIPLE_FORMS",
    "MONTHLY_REPORT_PAYOUT_ONE_FORM",
    "MONTHLY_REPORT_NO_PAYOUT_MULTIPLE_FORMS",
    "MONTHLY_REPORT_NO_PAYOUT_ONE_FORM",
    "DISPUTE_CREATED_ORGANIZATION_NOTIFICATION",
    "DISPUTE_CREATED_CUSTOMER_NOTIFICATION",
    "DISPUTE_CLOSED_ORGANIZATION_NOTIFICATION",
    "RADAR_EARLY_FRAUD",
    "ERROR_INSUFFICIENT_CAPABILITIES",
    "TICKET_TRANSFERRED_TO_NEW_OCCURRENCE",
    "ORG_PAGE_CREATED_DRAFT",
    "ORG_PAGE_PUBLISHED",
    "DONATION_FORM_CREATION",
    "DONATION_CREATION_ORGANISM_NOTIFICATION",
    "DONATION_MONTHLY_CANCELLED_ORGANISM_NOTIFICATION",
    "UPDATE_RECURRENT_DONATION_AMOUNT_ORG_NOTIFICATION",
    "UPDATE_RECURRENT_DONATION_AMOUNT_DONOR_NOTIFICATION",
    "NOTIFY_DONOR_ON_PAYMENT_METHOD_UPDATED",
    "ORGANIZATION_ORDER_EMAIL",
    "SHOP_ORGANIZATION_ORDER_EMAIL",
    "MEMBER_ONLY_TICKET_NO_VALID_MEMBERSHIP",
    "NOTIFY_MEMBER_ON_NEW_MEMBERSHIP_CARD",
    "SATISFACTION_SURVEY_EMAIL",
    "INDIVIDUAL_FUNDRAISING_OUTREACH",
    "SUGGEST_DESKTOP_COMPLETION_EMAIL",
    "GET_FEEDBACK_ON_MAILING_SENT",
    "NOTIFY_SENDER_EMAIL_STATS_READY",
    "RECEIPT_CANCELLED_DONOR_NOTIFICATION",
    "INVOICE_REMINDER",
    "INVOICE_REMINDER_SEVEN_DAYS_BEFORE",
    "INVOICE_REMINDER_ON_DUE_DATE",
    "INVOICE_REMINDER_SEVEN_DAYS_AFTER",
    "RESET_PASSWORD_LINK",
    "EMAIL_VERIFICATION",
    "EMAIL_CHANGED",
    "PASSWORD_CHANGED",
    "CONTACT_EMAIL_CHANGED_BY_USER",
    "USER_EMAIL_CHANGED_NOTIFICATION",
    "NEW_DEVICE",
    "ORGANIZATION_CREATION",
    "INVITE_AS_ORGANIZATION_MEMBER",
    "ADMIN_ADDED",
    "ADMIN_REVOKED",
    "OWNERSHIP_TRANSFERRED",
    "MERGE_USERS_REQUEST",
    "USER_FIRST_INVITATION_REMINDER",
    "USER_SECOND_INVITATION_REMINDER",
    "INVITATION_REFUSED",
    "NEW_NPO_STARTER_ORG_INVITATION",
    "NEW_NPO_STARTER_ORG_INVITATION_CATCHUP",
    "USER_FAILED_PAD_ACH",
    "USER_FAILED_RECURRING_CARD_PAYMENT",
    "USER_CARD_EXPIRING",
    "DELETE_IMPORT_SUCCESS",
    "DELETE_IMPORT_ERROR",
];
